import React, { useState } from 'react'
import CardHeadMenu from '../../Components/Card/CardHeadMenu/CardHeadMenu'
import { useSelector } from 'react-redux';
import RegistrationCard from './RegistrationCard';
import RegistrationTable from './RegistrationTable';
import CheckAndReturn from '../../utility/CheckAndReturn';

const RegistrationPage = () => {
    //#region 
    const { permissions, user_id } = useSelector(
        (state) => state.GlobalVariables
    );
    const [openDialog, setOpenDialog] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [callReset , setCallReset] = useState(false)

    const handleClickOpen = () => {
        setOpenDialog(!openDialog);
        setIsEdit(false)
        setEditData({})
        setCallReset(!callReset)
    };
    const handleClose = () => {
        setOpenDialog(false);
        // callReset()
    };
    const handleEdit = (data) => {
        setEditData(data);
        setOpenDialog(true);
    };
    //#endregion
    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"Registration"}
                handlePopup={
                    CheckAndReturn.PermissionHandler("create-registration", permissions)
                        ? handleClickOpen
                        : () => { } // empty function if no permission
                }
                create={openDialog}
            />

            <RegistrationCard
                handleClose={handleClose}
                open={openDialog}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                editData={editData}
                setEditData={setEditData}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                callReset={callReset}
            />
            <RegistrationTable
                handleEdit={handleEdit}
                isChanged={isChanged}

            />
        </>
    )
}

export default RegistrationPage
